import Grid from "@mui/material/Unstable_Grid2";
import { UseFormReturn } from "react-hook-form";
import { Groups } from "../../../components/groups/Groups";
import { FormatedField } from "../../../types/fields.types";
import { buildGroupedFields } from "../../../utils/buildGroupedFields";
import { ResponseScore } from "../psyEvaluations.types";

const EDITABLE_FIELDS = ["raw_score"];

type DimensionScoresGridProps = {
	scores: Array<ResponseScore>;
	formatedFields: Array<FormatedField>;
	entityForm?: UseFormReturn;
	type?: "detail" | "update";
};

export const DimensionScoresGrid = ({
	scores,
	formatedFields,
	entityForm,
	type = "detail",
}: DimensionScoresGridProps) => {
	const isEdit = type === "update";
	const groupColumnSize = scores.length === 1 ? 12 : scores.length === 2 ? 6 : 4;

	return (
		<Grid container justifyContent="flex-start" alignItems="top" display="flex" sx={{ backgroundColor: "#fff"}}>
			{scores.map((score) => {
				const fields = isEdit ? prefixFields(score.id, formatedFields) : formatedFields;
				const item = isEdit ? prefixItem(score.id, score) : score;
				const groupedFields = buildGroupedFields(fields, score.instrument_dimension?.name || "");

				return (
					<Grid key={score.id} px={4} pt={4} xs={12} lg={groupColumnSize} minWidth={300}>
						<Groups
							item={item}
							fields={groupedFields}
							entityForm={entityForm}
							type={type}
							bottomPadding={0}
						/>
					</Grid>
				);
			})}
		</Grid>
	);
};

const prefixFields = (scoreId: number, fields: Array<FormatedField>) => {
	return fields.map((field) => ({
		...field,
		field: `${scoreId}__${field.field}`,
		settings: {
			...field.settings,
			readonly: !EDITABLE_FIELDS.includes(field.field) || field.settings.readonly,
		},
	}));
};

const prefixItem = (scoreId: number, score: ResponseScore) => {
	const prefixed: Record<string, any> = {};
	for (const [key, value] of Object.entries(score)) {
		prefixed[`${scoreId}__${key}`] = value;
	}
	return prefixed;
};
